"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteHeader = void 0;
const common_1 = require("../../common");
const models_1 = require("../../hr/models");
const models_2 = require("../../partners/models");
const enums_1 = require("../enums");
const request_for_quote_file_model_1 = require("./request-for-quote-file.model");
const request_for_quote_line_model_1 = require("./request-for-quote-line.model");
class RequestForQuoteHeader extends common_1.MongoDocument {
}
exports.RequestForQuoteHeader = RequestForQuoteHeader;
//# sourceMappingURL=request-for-quote-header.model.js.map